"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/ui/Reveal";

export default function CatalogHeroClient() {
  return (
    <section aria-labelledby="catalog-heading" className="relative py-size-xl overflow-hidden bg-white">
      <div className="hidden lg:block">
        <div className="absolute top-0 bottom-0 w-px bg-mkt-outline-variant/20 left-[10%]" />
        <div className="absolute top-0 bottom-0 w-px bg-mkt-outline-variant/20 left-[30%]" />
        <div className="absolute top-0 bottom-0 w-px bg-mkt-outline-variant/20 left-[70%]" />
        <div className="absolute top-0 bottom-0 w-px bg-mkt-outline-variant/20 left-[90%]" />
      </div>
      <Reveal className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop">
        <h1
          id="catalog-heading"
          className="font-display-lg text-display-lg-mobile md:text-display-lg text-mkt-on-surface mb-size-md text-left"
        >
          AI learning built for your work.
        </h1>
        <p className="max-w-3xl font-body-lg text-[20px] text-mkt-on-surface-variant mb-size-lg text-left">
          Don&rsquo;t take another generic AI course. Find the learning path that fits your role, experience, and goals.
        </p>
        <div className="flex flex-col sm:flex-row items-start gap-size-sm sm:gap-size-md">
          <Link
            href="#courses"
            className="group inline-flex items-center gap-2 bg-mkt-primary-container text-mkt-on-primary font-headline-md text-body-lg px-size-lg py-size-sm rounded-lg primary-cta-glow transition-all hover:scale-105 active:scale-95"
          >
            Browse All Courses
            <ArrowRight
              aria-hidden="true"
              className="h-[1em] w-[1em] transition-transform duration-300 group-hover:translate-x-1"
            />
          </Link>
        </div>
        <p className="mt-size-md font-body-md text-body-lg font-bold text-mkt-primary">
          Personalized by AI. Validated by human experts.
        </p>
      </Reveal>
    </section>
  );
}
